export const handlePopUpClick: React.MouseEventHandler<HTMLDivElement> = (e) => e.stopPropagation();
